import { initRequest, request, BlockRequestConfig } from '@block/request';
import { Toast } from '@ss/mtd-react-mobile';
import { jump } from '@utils/navigate';

const AUTH_FAIL_CODE = 401;
const errorPool = new Set();

function authErrorToast(message, status) {
  const errorKey = `${status}-${message}`;
  if (!errorPool.has(errorKey)) {
    errorPool.add(errorKey);
    Toast.show({
      content: '登录失效, 2秒后将跳转至登录页面',
      onClose() {
        errorPool.delete(errorKey);
      },
    });
  }
}

initRequest({
  interceptors: {
    response: {
      onError: (error) => {
        const { message, status } = error ?? {};
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (parseInt(status!, 10) === AUTH_FAIL_CODE && window.location.pathname !== '/m/login') {
          const targetUrl = `${window.location.origin}/m/login?redirectUrl=${encodeURIComponent(window.location.href)}`;

          authErrorToast(message, status);
          setTimeout(() => {
            jump(targetUrl, { isAppendQuery: false });
          }, 2000);
        }

        return Promise.reject(error);
      },
    },
  },
  showErrorToast: true,
  mobileToast: Toast,
  timeout: 30 * 1000,
});

export async function get<T = any>(url: string, params?: any, config?: BlockRequestConfig): Promise<T> {
  return request.get(url, { params, ...config });
}

export async function post<T = any>(url: string, data?: any, config?: BlockRequestConfig): Promise<T> {
  return request.post(url, data, config);
}

export default { get, post };
